import React from "react";
import { Box } from "@mui/material";

const callTypes = [
  {
    label: "Outbound",
    value: "OUTBOUND",
  },
  {
    label: "Inbound",
    value: "INBOUND",
  },
  {
    label: "SIP Inbound",
    value: "OUTBOUND_INBOUND",
  },
  {
    label: "Redial",
    value: "REDIAL",
  },
];

const CallStatusFilter = ({ obj }) => {
  const { callTypeFilter, onChange } = obj;

  return (
    <Box className="mt-3">
      <span className="font-12-grey">Call Type</span>
      <Box>
        {callTypes.map((callType) => {
          return (
            <Box className="flex-align-center my-2" key={callType.value}>
              <input
                type="checkbox"
                id={callType.value}
                checked={callTypeFilter?.includes(callType.value)}
                onChange={() => onChange("callTypeFilter", callType.value)}
              />
              <label
                htmlFor={callType.value}
                className="font-12-grey ml-3 cursor-pointer check-label"
              >
                {callType.label}
              </label>
            </Box>
          );
        })}
      </Box>
    </Box>
  );
};

export default CallStatusFilter;
